import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="items-table"
export default class extends Controller {
  static targets = [
    "table"
  ];

  static values = {
    inventoryId: String,
  }

  receiveMultipleItems(){
    let item_ids = []
    let checkboxes = $(this.tableTarget).find(".item-checkbox")
    Object.keys(checkboxes).forEach(key => {
      let val = checkboxes[key]?.value
      if (val && checkboxes[key].checked) item_ids.push(val)
    });
  
    document.getElementById('turbo-modal').src = `/inventories/${this.inventoryIdValue}/receive_full_transfer_prompt?item_ids=${JSON.stringify(item_ids)}`
  }

  receiveItem(e){
    let item_id = e.target.closest("tr").getAttribute("data-item-id")
    document.getElementById('turbo-modal').src = `/inventories/${this.inventoryIdValue}/receive_full_transfer_prompt?item_ids=${JSON.stringify([item_id])}`
  }

}
